/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Form_Customer_Service_TagInputs */

const vi_carrier_form_customer_service_tag = /** @type {(inputs: Carrier_Form_Customer_Service_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khách chọn`)
};

/**

* @param {Carrier_Form_Customer_Service_TagInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_form_customer_service_tag = /** @type {((inputs?: Carrier_Form_Customer_Service_TagInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Form_Customer_Service_TagInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_form_customer_service_tag(inputs)
});